import React, { useState } from 'react';
import useModel from '../../api/model';
import Header from './Header';
import { mapSize } from '../../general';
import './Model.css';

export default ({ match }) => {
  const { name, gallery } = match.params;
  const [viewSize, setViewSize] = useState(3);
  const [images, sizes, names, galleries] = useModel(name, gallery, viewSize);
  return (
    <>
      <Header
        match={match}
        sizes={sizes}
        names={names}
        galleries={galleries}
        setViewSize={setViewSize}
        viewSize={viewSize}
      />
      {
        gallery === 'biography'
          ? (
            <div className="about" style={{whiteSpace: "pre-wrap"}}>{images}</div>
          ) : (
            <div className={mapSize(viewSize)}>
              {images}
            </div>
          )
      }
    </>
  );
};
